// import React,{ Component } from "react";

// import '../App.css'


// export default class Events extends Component{
//     render(){
//         return(
//             <div>
//                 Events
//             </div>
//         )
//     }
// }









import React from 'react';
import clsx from 'clsx';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';








const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
    },
}));

export default function PersistentDrawerLeft() {
    
    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);

    function handleDrawerOpen() {
        setOpen(true);
    }

    function handleDrawerClose() {
        setOpen(false);
    }

    return (
        <div className={classes.root}>
            <CssBaseline />
            <AppBar
                position="fixed"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="Open drawer"
                        onClick={handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, open && classes.hide)}
                    >
                        <MenuIcon />
                    </IconButton>
                    <Typography variant="h6" noWrap>
                        {/* Persistent drawer */}
                        ChromaFan
          </Typography>
                </Toolbar>
            </AppBar>
             <Drawer
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={open}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={classes.drawerHeader}>
                    <IconButton onClick={handleDrawerClose}>
                        {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    </IconButton>
                </div>
                <Divider />
                <List>
                    {['Events', 'Companies', 'User Admin', 'Assets', 'Shows'].map((text, index) => (
                        <ListItem button key={text}>
                            <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
                            <ListItemText primary={text} />
                        </ListItem>
                    ))}
                </List>
                {/* <Divider /> 
                {/* <List>
          {['All mail', 'Trash', 'Spam'].map((text, index) => (
            <ListItem button key={text}>
              <ListItemIcon>{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}</ListItemIcon>
              <ListItemText primary={text} />
            </ListItem>
          ))}
        </List> */}
             </Drawer> 





            <main
                className={clsx(classes.content, {
                    [classes.contentShift]: open,
                })}
            >
                <div className={classes.drawerHeader} />


                <div style={{ textAlign: 'center', margin: '2%' }}>
                
                    <p>Event name:<span style={{ fontWeight: 'bold' }}>  Barclays Premier League  </span>  </p>
                    <p>Stadium Location:<span style={{ fontWeight: 'bold' }}>Oval</span></p>
                    <p>Event Date:<span style={{ fontWeight: 'bold' }}>2 July 2019</span></p>
                    <p>Event Time:<span style={{ fontWeight: 'bold' }}>20:00 IST</span></p>

                </div>

                {/* <Divider /> */}
               
               
                <section>
                    <div className="container">

                        <div style={{ display: 'flex', flexDirection: 'row', padding: '4%' }}>
                            <div style={{ width: '100%', border: "1px solid black" }} >
                                <h3 style={{ fontSize: 30, fontWeight: 'bold', textAlign: 'center' }}  > Team A </h3>
                                <div style={{ textAlign: "center" }}>
                                    <p>Manchester United</p>
                                    <p>Logo:</p>
                                    <p>hex1:</p>
                                    <p>hex1:</p>
                                </div>
                            </div>

                            <div style={{ width: '100%', border: '1px solid black' }}>
                                <h3 style={{ fontSize: 30, fontWeight: 'bold', textAlign: 'center' }}  > Team B </h3>
                                <div style={{ textAlign: "center" }}>
                                    <p>Manchester City</p>
                                    <p>Logo:</p>
                                    <p>hex1:</p>
                                    <p style={{ borderRadius: 10, borderColor: 'black', borderWidth: 10 }}>1 </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>



            </main>
        </div>
    );
}






